const Card = ({ x, y, rotation, suit, color, delay }) => (
  <g transform={`translate(${x} ${y}) rotate(${rotation} 100 150)`}>
    <g
      className="footer-cards-svg__card"
      style={{ "--card-delay": `${delay}s` }}
    >
      <rect
        x="0"
        y="0"
        width="200"
        height="300"
        rx="20"
        fill="url(#footer-card-face)"
        stroke="rgba(255,255,255,.9)"
        strokeWidth="3"
        filter="url(#footer-card-shadow)"
      />
      <path
        d="M18 18 H182"
        stroke="rgba(255,255,255,.85)"
        strokeWidth="4"
        strokeLinecap="round"
      />
      <text
        x="24"
        y="48"
        fill={color}
        fontFamily="Georgia, 'Times New Roman', serif"
        fontSize="34"
        fontWeight="700"
      >
        A
      </text>
      <text
        x="27"
        y="77"
        fill={color}
        fontFamily="Georgia, 'Times New Roman', serif"
        fontSize="28"
      >
        {suit}
      </text>
      <text
        x="100"
        y="196"
        fill={color}
        textAnchor="middle"
        fontFamily="Georgia, 'Times New Roman', serif"
        fontSize="116"
      >
        {suit}
      </text>
      <g transform="translate(200 300) rotate(180)">
        <text
          x="24"
          y="48"
          fill={color}
          fontFamily="Georgia, 'Times New Roman', serif"
          fontSize="34"
          fontWeight="700"
        >
          A
        </text>
        <text
          x="27"
          y="77"
          fill={color}
          fontFamily="Georgia, 'Times New Roman', serif"
          fontSize="28"
        >
          {suit}
        </text>
      </g>
    </g>
  </g>
);

const Chip = ({ x, y, color, delay, scale = 1 }) => (
  <g transform={`translate(${x} ${y}) scale(${scale})`}>
    <g
      className="footer-cards-svg__chip"
      style={{ "--chip-delay": `${delay}s` }}
      filter="url(#footer-chip-shadow)"
    >
      <ellipse
        className="footer-cards-svg__chip-edge"
        cx="0"
        cy="6"
        rx="62"
        ry="38"
        fill={color}
        stroke="#8d96a3"
        strokeWidth="3"
      />
      <ellipse cx="0" cy="0" rx="62" ry="38" fill="#f8fafc" />
      <g transform="scale(1 .62)">
        <g className="footer-cards-svg__chip-spin">
          <circle
            cx="0"
            cy="0"
            r="58"
            fill="none"
            stroke={color}
            strokeWidth="18"
            strokeDasharray="25 12"
          />
          <circle
            cx="0"
            cy="0"
            r="37"
            fill="url(#footer-chip-center)"
            stroke={color}
            strokeWidth="4"
          />
          <ellipse
            cx="-13"
            cy="-16"
            rx="17"
            ry="9"
            fill="rgba(255,255,255,.55)"
            transform="rotate(-15)"
          />
        </g>
      </g>
    </g>
  </g>
);

const FooterCardsSvg = () => (
  <div className="atheriam-footer__cards" aria-hidden="true">
    <svg
      viewBox="0 0 800 620"
      role="presentation"
      className="footer-cards-svg"
    >
      <defs>
        <linearGradient id="footer-card-face" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#ffffff" />
          <stop offset=".55" stopColor="#f8f8f8" />
          <stop offset="1" stopColor="#dedede" />
        </linearGradient>
        <radialGradient id="footer-chip-center" cx=".35" cy=".25" r=".8">
          <stop offset="0" stopColor="#ffffff" />
          <stop offset=".7" stopColor="#eeeeee" />
          <stop offset="1" stopColor="#c7c7c7" />
        </radialGradient>
        <filter
          id="footer-card-shadow"
          x="-35%"
          y="-25%"
          width="170%"
          height="170%"
        >
          <feDropShadow
            dx="10"
            dy="18"
            stdDeviation="14"
            floodColor="#000"
            floodOpacity=".3"
          />
        </filter>
        <filter
          id="footer-chip-shadow"
          x="-60%"
          y="-80%"
          width="220%"
          height="260%"
        >
          <feDropShadow
            dx="8"
            dy="13"
            stdDeviation="9"
            floodColor="#000"
            floodOpacity=".38"
          />
        </filter>
      </defs>

      <ellipse
        className="footer-cards-svg__ground"
        cx="405"
        cy="530"
        rx="300"
        ry="38"
        fill="rgba(0,0,0,.16)"
      />

      <Card
        x={110}
        y={185}
        rotation={-37}
        suit="♠"
        color="#0b0b0b"
        delay={0}
      />
      <Card
        x={215}
        y={105}
        rotation={-15}
        suit="♥"
        color="#ef2027"
        delay={0.08}
      />
      <Card
        x={322}
        y={80}
        rotation={4}
        suit="♦"
        color="#ef2027"
        delay={0.16}
      />
      <Card
        x={442}
        y={126}
        rotation={24}
        suit="♣"
        color="#151515"
        delay={0.24}
      />

      <Chip x={185} y={105} color="#1675d1" delay={0} scale={0.82} />
      <Chip x={535} y={125} color="#1675d1" delay={0.5} scale={0.9} />
      <Chip x={425} y={42} color="#e02626" delay={0.25} scale={0.76} />
      <Chip x={204} y={488} color="#e02626" delay={0.75} scale={1.02} />
      <Chip x={600} y={470} color="#1675d1" delay={1} scale={0.94} />
    </svg>
  </div>
);

export default FooterCardsSvg;
